import { jsxs, jsx } from 'react/jsx-runtime';
import { Bin } from '@zooplus/icons';
import CardIcon from '../CardIcon/CardIcon.js';
import CreditCardInfo from '../CreditCardInfo/CreditCardInfo.js';
import StateBox from '../StateBox/StateBox.js';
import { useTranslation } from '../../hooks/useTranslations.js';
import { cardTypeOfCreditCardBrand } from '../../types-internal/ModernizePaymentTypes.js';
import { handleKeyDown } from '../../utils/utils.js';
import styles from './CreditCardNew.module.scss.js';

const CreditCardNew = ({ creditCard, onDelete, onSelect, showIcons, status, }) => {
    const { t } = useTranslation();
    const isSessionCard = creditCard.pspIdentifier === '0';
    const isBancontactCard = creditCard.paymentMethod === 'BANCONTACT';
    const onDeleteHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();
        onDelete?.(e);
    };
    let variant = 'default';
    if (creditCard.expired)
        variant = 'error';
    if (creditCard.selected)
        variant = 'selected';
    return (jsxs(StateBox, { variant: variant, onClick: onSelect, className: "creditCard", hasHoverEffect: true, "data-testid": isBancontactCard
            ? 'storedBCWrapper'
            : isSessionCard
                ? 'storedSessionCC'
                : creditCard.selected
                    ? 'storedSelectedCC'
                    : 'storedCC', "data-zta": isSessionCard ? 'storedSessionCC' : creditCard.selected ? 'storedSelectedCC' : 'storedCC', children: [jsxs("div", { className: styles.creditCardRowContainer, children: [isBancontactCard ? (jsx(CardIcon, { "data-testid": "ccIcon", type: 'cartebancontact' })) : (creditCard.brand && (jsx(CardIcon, { "data-testid": "ccIcon", type: cardTypeOfCreditCardBrand[creditCard.brand] }))), showIcons && variant === 'error' && creditCard.expired && (jsx("div", { className: styles.expiredContainer, children: t('checkout.payment.creditcard.expired.message') })), showIcons && onDelete && (jsx("span", { className: styles.delete, "data-testid": isBancontactCard ? 'removeBCCard' : 'removeCC', "data-zta": "removeCC", onClick: onDeleteHandler, onKeyDown: (e) => handleKeyDown(e, onDelete), role: "button", tabIndex: 0, children: jsx(Bin, {}) }))] }), jsx("div", { className: styles.cardHolderName, children: creditCard.holderName }), jsx(CreditCardInfo, { isBancontactCard: isBancontactCard, lastFourDigits: creditCard.maskedNumber, expirationMonth: creditCard.expirationMonth, expirationYear: creditCard.expirationYear }), variant === 'selected' && status === 'loading' && (jsx("div", { className: styles.loaderBackdrop, children: jsx("div", { className: styles.loaderLarge }) }))] }));
};

export { CreditCardNew as default };
//# sourceMappingURL=CreditCardNew.js.map
